export const getTrimCardKey = (trim) => {
    const defaultTransmission = trim.transmissions.find(transmission => transmission.transmissionKey === trim.defaultTransmission);
    const key = `${trim === null || trim === void 0 ? void 0 : trim.trimKey}-${trim.defaultTransmission}-${defaultTransmission === null || defaultTransmission === void 0 ? void 0 : defaultTransmission.exteriorColorKey}-${defaultTransmission === null || defaultTransmission === void 0 ? void 0 : defaultTransmission.interiorColorKey}-${trim.inventoryStatus}`;
    return key;
};
export default getTrimCardKey;
